import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TextsService {
  // Methods
  /**
   * returns the first name and the initial of the last name.
   * @param fullName - The full name to format
   * @returns Firstname full and last name initial + .
   */
  formatName(fullName: string): string {
    const nameParts = fullName.split(' ');
    if (nameParts.length < 2) {
      return fullName;
    }
    if (nameParts.length > 2) {
      const firstName = nameParts.slice(0, -1).join(' ');
      const lastNameInitial = nameParts[nameParts.length - 1].charAt(0).toUpperCase();
      return `${firstName} ${lastNameInitial}.`;
    }
    const firstName = nameParts[0];
    const lastNameInitial = nameParts[1].charAt(0).toUpperCase();
    return `${firstName} ${lastNameInitial}.`;
  }
}
